
<template>
  <div class="the-navbar__user-meta flex items-center">
<!--
修改为点击之后菜单收起来
-->
    <div class="nav-bar-right">
      <span class="username user-name-p">{{username}}</span>
      <el-dropdown
        :show-timeout="0"
        placement="bottom"
        class="dropdown-root"
      >
        <span
          class="el-dropdown-link">
            <img
              v-if="avatarUrl"
              class="avatar-img"
              :src="avatarUrl"
              alt=""
            >
            <img
              v-if="defaultAvatarFlag"
              class="avatar-img"
              :src="defaultAvatar"
              alt=""
            >
        </span>
        <el-dropdown-menu
          class="dropdown-menu"
          slot="dropdown">
          <el-dropdown-item
            class="self-dropdown-item-two front"
            @click.native="updatePasswordHandle()"
          >
            <div class="item-two-inner">
              <icon-svg
                class="icon-el-dropdown"
                icon-class="xiugai"
              ></icon-svg>
              <span>修改账户信息</span>
            </div>
          </el-dropdown-item>
          <el-dropdown-item
            class="self-dropdown-item-two back"
            @click.native="logout"
          >
            <div class="item-two-inner">
              <icon-svg
                class="icon-el-dropdown"
                icon-class="tuichudenglu"
              ></icon-svg>
              <span>退出登录</span>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <edit-password-dialog
      ref="dialog"
    ></edit-password-dialog>
    <edit-info-dialog
      ref="infodialog"
      @upload-avatar-success="uploadAvatarSuccess"
      @edit-pass="editPass"
    ></edit-info-dialog>
  </div>
</template>

<script>
import editInfoDialog from "@/components/home/editInfoDialog";
import editPasswordDialog from "@/layouts/components/navbar/components/editPasswordDialog";
import defaultAvatar from '@/assets/images/defaultAvatar.png'
import { mapGetters } from 'vuex'
import { clearLoginInfo } from "@/utils";
import { queryUserInfo } from "@/api/user";
export default {
    components:{
      editPasswordDialog,
      editInfoDialog,
    },
  data() {
    return {
      defaultAvatar,
      avatarUrl: '',
    }
  },
  created(){
    this.getUserInfo();
  },
  computed: {
    ...mapGetters(['userInfo','listRefresh']),
    username(){
      return this.userInfo.username;
    },
    defaultAvatarFlag(){
      return this.avatarUrl !== '' && this.avatarUrl === null;
    },
  },
  methods: {
    getUserInfo(){
      queryUserInfo().then((data) => {
        this.avatarUrl = data.user.avatar;
        this.$store.commit('setUserInfo', data.user);
      })
    },
    uploadAvatarSuccess(){
      this.getUserInfo();
      // this.$refs.infodialog.dialogShow = false;
    },
    updatePasswordHandle(){
      this.$refs.infodialog.dialogShow = true;
    },
    logout() {
      clearLoginInfo(this.$router);
      localStorage.clear();

      this.$router.push({name: 'login'}).catch(() => {})
    },
    editPass(){
      this.$refs.infodialog.dialogShow = false;
      this.$refs.dialog.dialogShow = true;
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../assets/scss/variable";
.self-dropdown-item {
  &:hover {
    color: $themeColor;
  }
  .user-name {
    font-weight: 600;
    font-size: 14px;
    color: #5E5873;
  }
  .icon-el {
    font-size: 16px;
    margin-right: 10px;
  }
  .feather-icon-el {
    margin-right: 10px;
    > svg {
      width: 1.2rem;
      height: 1.2rem;
    }
  }
}
  .self-dropdown-item-two {
    height: 41px;
    &.front {
      border-bottom: 1px solid #EFF3FF;
    }
    .item-two-inner {
      display: flex;
      justify-content: start;
      align-items: center;
      font-size: 16px;
      .icon-el-dropdown {
        margin-right: 10px;
        font-size: 18px;
      }
    }
  }
.vs-dropdown--custom {

}
.user-name-p {
  padding-left: 5px;
}
.avatar-img {
  width: 38px;
  height: 38px;
  border-radius: 50%;
}
</style>
<style lang="scss" scoped>
.self-dropdown-item:not(.is-disabled):hover {
  background-color: #ffffff!important;
}
.self-dropdown-item {
  line-height: 1.5!important;
}


.username {
  font-size: 14px;
  color: #585B73;
  font-weight: bold;
  padding-right: 10px;
}
.dropdown-root {

}
.dropdown-menu.el-dropdown-menu {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
